import { AbilityPrograms } from "./home/ability"
import { AlignedGlobally } from "./home/sdg"
import { BottomCta } from "./home/cta"
import { CorePillars } from "./home/pillars"
import { EventsSection } from "./home/events"
import { Hero } from "./home/hero"
import { OurWhy } from "./home/why"
import { PartnerSchools } from "./home/schools"
import { SponsorshipSteps } from "./home/steps"

export function HomePage() {
  return (
    <>
      <Hero />
      <CorePillars />
      <OurWhy />
      <SponsorshipSteps />
      <PartnerSchools />
      <AbilityPrograms />
      <AlignedGlobally />
      <EventsSection />
      <BottomCta />
    </>
  )
}
